export default __webpack_public_path__ + "static/media/gear-nextsong.3f174783.png";